import { FC } from 'react'
import { match } from 'ts-pattern'
import { useCubeContext } from 'modules/Cube/communication/internal/cube.domain.context'
import { ExecuteNewBusinessQuoteModal } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/ExecuteNewBusinessQuote.modal'
import { ExecuteRenewalQuoteModal } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/ExecuteRenewalQuote.modal'
import { ExecuteAmendmentQuoteModal } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/ExecuteAmendmentQuote.modal'
import type { QuoteExecuteScheduleAction } from 'modules/Cube/communication/external/quotes.api.v1/ports/entitySaving/useSaveQuote'

type ExecuteQuoteModalProps = {
  onClose: () => void
  onConfirm: (result: {
    startDate: Date | undefined
    scheduleAction: QuoteExecuteScheduleAction
  }) => void
  submitting: boolean
}

/**
 * Routes by deal type: renewals get the two-step modal, amendments a confirm
 * dialog that amends the linked schedule, and new business the
 * create-billing-schedule dialog.
 */
export const ExecuteQuoteModal: FC<ExecuteQuoteModalProps> = props => {
  const cubeContext = useCubeContext()

  return match(cubeContext.queries.rawData.data.quote.dealType)
    .with('RENEWAL', () => <ExecuteRenewalQuoteModal {...props} />)
    .with('AMENDMENT', () => (
      <ExecuteAmendmentQuoteModal onClose={props.onClose} />
    ))
    .with('NEW_BUSINESS', () => <ExecuteNewBusinessQuoteModal {...props} />)
    .exhaustive()
}
